import * as types from './types';
import moment from 'moment';

const INITIAL_STATE = {
  noteRowInfo: {},
  studentNotesInfo: [],
  saveNotesInfo: '',
  notesState: {
    selected: -1,
    isNew: true,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.STUDENT_NOTES_GET_NOTES:
      action.payload.Data.forEach(x => {
        x.formattedDate = moment(x.ModifiedDT).format('MM/DD/YYYY h:mm:ss A');
      });
      return {
        ...state,
        studentNotesInfo: action.payload.Data,
      };
    case types.STUDENT_NOTES_NOTEROWUPDATE:
      return {
        ...state,
        noteRowInfo: action.payload,
      };
    case types.STUDENT_NOTES_SAVE_NOTES:
      return {
        ...state,
        saveNotesInfo: action.payload,
      };
    case types.STUDENT_NOTES_UPDATENOTES:
      return {
        ...state,
        notesState: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/Components/StudentNoteModal/state/reducer.js